<template>
  <div class="my-3">
    <label>Build A List Of Users For Adding Points</label>
    <div class="row p-3">
      <div class="col-sm-6 col-md-6 border p-3">
        <label>Simple Search</label>
        <b-input-group>
          <b-form-input v-model="searchTerm"></b-form-input>
          <b-input-group-append>
            <b-button variant="primary" @click="simpleSearch()">
              <font-awesome-icon icon="search" />
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <div class="my-3">
          <p v-b-toggle.collapse-1>
            Search Instructions (click here to get more info)
          </p>
          <b-collapse id="collapse-1">
            <b-card
              ><ul>
                <li>
                  <p>
                    <strong>Search Instructions :</strong> Use the Simple Search
                    to find users quickly! Type in a <strong>name</strong> or
                    <strong>partial name</strong> or
                    <strong>the users code</strong> (a custom field that often
                    means "dept" or "location") and click the Search button to
                    see only the users with matching first name, last name or
                    code. To select all users, simply clear the keyword box and
                    click the Search button.
                  </p>
                </li>
              </ul></b-card
            >
          </b-collapse>
        </div>
      </div>
      <div class="col-sm-6 col-md-6 border p-3">
        <div class="my-3">
          <label>Advanced Search</label>
          <button
            variant="primary"
            class="btn btn-primary float-right"
            @click="advanceSerach()"
          >
            <font-awesome-icon icon="search" />
          </button>
          <div class="my-3">
            <p v-b-toggle.collapse-3>(click here to advanced search)</p>
            <b-collapse id="collapse-3">
              <b-card>
                <div class="row">
                  <div class="col-sm-6 col-md-6">
                    <label>First Name</label>
                    <b-form-input
                      v-model="advancedSerach.firstName"
                    ></b-form-input>
                    <label class="my-1">User Name</label>
                    <b-form-input
                      v-model="advancedSerach.username"
                    ></b-form-input>
                    <label class="my-1">City</label>
                    <b-form-input v-model="advancedSerach.city"></b-form-input>
                    <label class="my-1">Phone No.</label>
                    <b-form-input
                      v-model="advancedSerach.phoneNumber"
                    ></b-form-input>
                    <label class="my-1">Email</label>
                    <b-form-input v-model="advancedSerach.email"></b-form-input>
                  </div>
                  <div class="col-sm-6 col-md-6">
                    <label>Last Name</label>
                    <b-form-input
                      v-model="advancedSerach.lastName"
                    ></b-form-input>
                    <label class="my-1">Code</label>
                    <b-form-input v-model="advancedSerach.code"></b-form-input>
                    <label class="my-1">State/Zip</label>
                    <div class="row">
                      <div class="col-sm-6 col-md-6">
                        <b-form-input
                          v-model="advancedSerach.state"
                        ></b-form-input>
                      </div>
                      <div class="col-sm-6 col-md-6">
                        <b-form-input
                          v-model="advancedSerach.zip"
                        ></b-form-input>
                      </div>
                    </div>
                    <label class="my-1">SS No.</label>
                    <b-form-input v-model="advancedSerach.ssn"></b-form-input>
                    <label class="my-1">Select</label>
                    <b-form-select v-model="advancedSerach.clientId">
                      <option
                        v-for="option in SelectCompanyOptions"
                        :key="option.value"
                        :value="option.value"
                      >
                        {{ option.text }}
                      </option>
                    </b-form-select>
                  </div>
                </div>
              </b-card>
            </b-collapse>
          </div>
        </div>
      </div>
    </div>
    <div class="row p-3">
      <div class="col-sm-12 col-md-12 border p-3">
        <label
          >Search Results (<strong
            >Total Users :
            {{ parseInt(pagination.total).toLocaleString() }}</strong
          >)</label
        >
        <b-button @click="selectAll()" variant="primary" class="float-right"
          >Select All</b-button
        >
        <div class="my-3">
          <p v-b-toggle.collapse-2>
            Basic Instructions (click here to get more info)
          </p>
          <b-collapse id="collapse-2">
            <b-card
              ><ul>
                <li>
                  <p>
                    Select the desired users by clicking on the check box next
                    to their record. You can also "select all" users in this
                    list using the "select all" button at the right. This list
                    displays 500 users at a time. Use the "next" and "previous"
                    buttons to page through your lists of users.
                  </p>
                </li>
              </ul></b-card
            >
          </b-collapse>
        </div>
      </div>
    </div>
    <a-table
      :columns="UserFields"
      :data-source="UserItems"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      bordered
      :row-key="(record) => record.id"
    >
      <span slot="points" slot-scope="text, record">
        <span v-if="record.points < 0" class="badge badge-danger">{{
          record.points
            ? parseInt(record.points)
                .toFixed(2)
                .replace(/\d(?=(\d{3})+\.)/g, "$&,")
            : "0.00"
        }}</span>
        <span v-else-if="record.points >= 0" class="badge badge-success">{{
          record.points
            ? parseInt(record.points)
                .toFixed(2)
                .replace(/\d(?=(\d{3})+\.)/g, "$&,")
            : "0.00"
        }}</span>
      </span>
      <span slot="choose" slot-scope="text, record">
        <b-form-checkbox
          v-model="selected"
          :name="record.clientId.toString()"
          :value="
            Object({
              ...record,
            })
          "
        >
        </b-form-checkbox>
      </span>
    </a-table>
    <div class="row p-3">
      <div class="col-sm-12 col-md-12 border p-3">
        <label
          >Currently Selected Users (<strong
            >Selected Users :
            {{
              selected.length > 0
                ? parseInt(selected.length).toLocaleString()
                : 0
            }}</strong
          >)</label
        >
        <div
          style="overflow-x: hidden"
          class="row usersSelected"
          v-if="selected.length > 0"
        >
          <div v-for="item in selected" :key="item.id" class="m-1">
            <b-button class="alert-class" @click="filterSelected(item.id)" show
              >{{ item.userName }}<font-awesome-icon class="ml-1" icon="times"
            /></b-button>
          </div>
        </div>
        <div class="row" v-else>
          <div class="col-sm-4 col-md-4">
            <b-button class="alert-class" dismissible show
              >No Users Selected <font-awesome-icon icon="times"
            /></b-button>
          </div>
        </div>
      </div>
    </div>
    <div class="row my-2">
      <div class="col-sm-2 col-md-2">
        <b-button
          :disabled="!selected.length"
          variant="primary"
          class="m-2"
          v-on:click="finalize()"
          >Continue</b-button
        >
      </div>
      <div class="col-sm-10 col-md-10">
        <p class="m-2">
          (Once you have found all the users to which you wish to add points,
          click the continue button. You can edit the entire list on the next
          page.)
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import router from "../../../../router/index";

export default {
  name: "AddPointsBuildListOfUsers",
  data() {
    return {
      advancedSerach: {
        firstName: "",
        lastName: "",
        username: "",
        code: "",
        city: "",
        state: "",
        zip: "",
        phoneNumber: "",
        ssn: "",
        email: "",
        client_id: Number(this.$route.params.clientId),
      },
      sortDesc: false,
      selected: [],
      allUsers: [],
      searchTerm: "",
      sortField: "",
      sortOrder: "",
      pagination: {
        total: 0,
        showTotal: (total, range) => (
          <div>
            <div>
              {range[0]}-{range[1]} of {total} items
            </div>
            <li class="pagination-item" title="First Page">
              <button
                type="button"
                class="btn btn-primary"
                disabled={this.pagination.current === 1}
                onClick={() => this.goToPage(1)}
              >
                <font-awesome-icon icon="angle-double-left" class="m-0" />
              </button>
            </li>
          </div>
        ),
        itemRender: (current, type, originalElement) => {
          const goToNextPage = () => this.goToPage(this.pagination.current + 1);
          const totalPages = Math.ceil(
            this.pagination.total / this.pagination.pageSize
          );
          if (type === "next") {
            return (
              <div class="next-buttons" onClick={(e) => e.stopPropagation()}>
                <li class="pagination-item">
                  <button
                    type="button"
                    class="btn btn-primary"
                    disabled={totalPages === this.pagination.current}
                    onClick={goToNextPage}
                  >
                    <font-awesome-icon icon="angle-right" class="m-0" />
                  </button>
                </li>
                <li class="pagination-item" title="Last Page">
                  <button
                    type="button"
                    class="btn btn-primary"
                    disabled={totalPages === this.pagination.current}
                    onClick={() => this.goToPage(totalPages)}
                  >
                    <font-awesome-icon icon="angle-double-right" class="m-0" />
                  </button>
                </li>
              </div>
            );
          }
          return originalElement;
        },
        hideOnSinglePage: true,
      },
      loading: false,
      fetchParameters: {
        searchTerm: "",
        firstName: "",
        lastName: "",
        username: "",
        code: "",
        city: "",
        state: "",
        zip: "",
        phoneNumber: "",
        ssn: "",
        email: "",
        client_id: Number(this.$route.params.clientId),
        programId: Number(this.$route.params.programId),
        pageNumber: 1,
        pageSize: 5,
        sortField: "",
        sortOrder: "",
      },
      UserFields: [
        {
          title: "Username",
          key: "userName",
          dataIndex: "userName",
          sorter: true,
        },
        {
          title: "First Name",
          key: "firstName",
          dataIndex: "firstName",
          sorter: true,
        },
        {
          title: "Last Name",
          key: "lastName",
          dataIndex: "lastName",
          sorter: true,
        },
        {
          title: "Client Name",
          key: "name",
          dataIndex: "clientName",
        },
        {
          title: "Points",
          key: "points",
          dataIndex: "points",
          scopedSlots: { customRender: "points" },
          sorter: true,
          align: "right",
        },
        {
          title: "Select",
          key: "choose",
          sortable: false,
          scopedSlots: { customRender: "choose" },
        },
      ],
      UserItems: [],
      toggleSelect: true,
    };
  },
  created() {
    this.loading = true;
    this.$store
      .dispatch("adminAddPoint/getUsers", { ...this.fetchParameters })
      .then(async (data) => {
        const allUserData = await this.$store.dispatch(
          "adminAddPoint/getUsers",
          { ...this.fetchParameters, pageSize: data.totalRecords }
        );
        this.loading = false;
        this.allUsers = allUserData.Result;
        this.UserItems = allUserData.Result;
        const pagination = { ...this.pagination };
        pagination.total = data.totalRecords;
        pagination.pageSize = data.totalRecords;
        this.pagination = pagination;
      });
    this.$store.dispatch("adminAddPoint/fetchAuthorizedClients");
  },

  methods: {
    goToPage(page) {
      const pager = { ...this.pagination };
      pager.current = page;
      this.pagination = pager;
      this.fetchParameters = {
        ...this.fetchParameters,
        pageNumber: page,
      };
      this.getPointsData();
    },
    filterSelected(user_id) {
      this.selected = this.selected.filter((data) => data.id != user_id);
    },
    handleTableChange(pagination, filters, sorter) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.fetchParameters = {
        ...this.fetchParameters,
        pageSize: pagination.pageSize,
        pageNumber: pagination.current,
        sortField: sorter.field ?? "",
        sortOrder:
          sorter.order === "ascend"
            ? "ASC"
            : sorter.order === "descend"
            ? "DESC"
            : "",
      };
      this.getPointsData();
    },
    getPointsData() {
      this.loading = true;
      this.$store
        .dispatch("adminAddPoint/getUsers", { ...this.fetchParameters })
        .then(async (data) => {
          const pagination = { ...this.pagination };
          pagination.total = data.totalRecords;
          pagination.pageSize = 5;
          this.loading = false;
          this.UserItems = data.Result;
          this.pagination = pagination;
          const allUserData = await this.$store.dispatch(
            "adminAddPoint/getUsers",
            { ...this.fetchParameters, pageSize: data.totalRecords }
          );
          this.allUsers = allUserData.Result;
          this.UserItems = allUserData.Result;
          this.pagination.total = data.totalRecords;
          this.pagination.pageSize = data.totalRecords;
        });
    },
    selectAll() {
      if (this.toggleSelect) {
        this.selected = this.allUsers.map((record) =>
          Object({
            ...record,
          })
        );
        this.toggleSelect = !this.toggleSelect;
      } else {
        this.selected = [];
        this.toggleSelect = !this.toggleSelect;
      }
    },
    simpleSearch() {
      this.fetchParameters = {
        ...this.fetchParameters,
        searchTerm: this.searchTerm,
        firstName: "",
        lastName: "",
        username: "",
        code: "",
        city: "",
        state: "",
        zip: "",
        phoneNumber: "",
        ssn: "",
        email: "",
        client_id: Number(this.$route.params.clientId),
      };
      this.getPointsData();
    },
    advanceSerach() {
      this.fetchParameters = {
        ...this.fetchParameters,
        ...this.advancedSerach,
        searchTerm: "",
      };
      this.getPointsData();
    },
    finalize() {
      this.$store.dispatch("adminAddPoint/setSelectedUsers", this.selected);
      router.push({
            name: 'AdminAddPointsFinalizeListOfUsers',
            params: {
              programId: this.$route.params.programId,
              clientId: this.$route.params.clientId,
            },
          });
    },
  },
  computed: {
    ...mapState({
      SelectCompanyOptions: (state) => [
        { value: "All", text: "Search All Locations" },
        ...state.adminAddPoint.AuthorizedClients.map(
          ({ clientId, clientName }) => {
            return { value: clientId.toString(), text: clientName };
          }
        ),
      ],
    }),
  },
};
</script>

<style lang="scss" scoped>
.alert-class {
  background-color: rgba(55, 130, 243, 1);
  color: white;
}
.usersSelected {
  max-height: 300px;
  overflow-y: scroll;
}
</style>
